/// <amd-module name="Build/SourceProviders/ExternalGit" />

import { BaseGit } from "Build/SourceProviders/BaseGit";
import { IRepositoryInfo, RepositoryTypes } from "Build/SourceProviders/Common";
import * as Resources from "Build/SourceProviders/Resources";
import { IVCNavigationService } from "VC/Common/Navigation";

export class ExternalGit extends BaseGit {
    public getKey() {
        return RepositoryTypes.ExternalGit;
    }

    public getName() {
        return Resources.ExternalGit;
    }

    public fetchRepositoryLink(info: IRepositoryInfo, projectName?: string): Promise<string | null> {
        return Promise.resolve(this._getRepositoryLinkInternal(info.repositoryId));
    }

    protected _getRepositoryLink(info: IRepositoryInfo, service: IVCNavigationService): string {
        return this._getRepositoryLinkInternal(info.repositoryId);
    }

    private _getRepositoryLinkInternal(repositoryId?: string): string {
        if (repositoryId) {
            return repositoryId
        }

        return "";
    }
}
